// Translation lookup. `t(key)` resolves a dot-path against the active locale's
// dictionary, falling back to en-GB, then to the key itself (so missing keys are
// visible rather than blank). Returns whatever the dictionary holds — strings
// get optional {var} interpolation; arrays/objects pass through for the caller
// to map over (lists, FAQ entries, etc.).
//
// Locale is fixed for the lifetime of a page (switching language navigates), so
// no React subscription is needed: components can import `t` directly.

import { getDict, getFallbackDict } from './bootstrap.js';

function lookup(dict, key) {
  if (!dict) return undefined;
  let cur = dict;
  for (const part of key.split('.')) {
    if (cur == null || typeof cur !== 'object') return undefined;
    cur = cur[part];
  }
  return cur;
}

function interpolate(value, vars) {
  if (!vars || typeof value !== 'string') return value;
  return value.replace(/\{(\w+)\}/g, (m, k) => (k in vars ? String(vars[k]) : m));
}

export function t(key, vars) {
  let val = lookup(getDict(), key);
  if (val === undefined) val = lookup(getFallbackDict(), key);
  if (val === undefined) return key;
  return interpolate(val, vars);
}

// Hook form for ergonomic call sites. Returns the stable `t`.
export function useT() {
  return t;
}
